module.exports = __webpack_public_path__ + "5d370628f0bff7108f9d03d4f629d041.svg";